/**
 * Filas de atendimento.
 *
 * Fica em "Configuracao" e nao em "Atendimento" porque quem mexe aqui nao e
 * quem atende: e uma tela de desenho do setor -- estrategia de distribuicao,
 * SLA, horario e quais equipes atendem.
 */
export const nav = {
    permissao: 'atendimento.filas:ver',
    section: 'Configuracao',
    title: 'Filas',
    icon: 'call_split',
    route: '/filas',
    sequence: 10,
};

export default [
    {
        path: '/filas',
        name: 'filas',
        component: () => import('./pages/FilasPage.vue'),
        meta: { requiresAuth: true, permissao: 'atendimento.filas:ver' },
    },
];
